import { Invoice, InvoiceGroupDetails, InvoiceLineItem } from 'src/redux/billing/billing.types';

/** Normalise API list rows so UI always has an invoice_line_items array. */
export function normaliseInvoiceGroupDetails(details: InvoiceGroupDetails): InvoiceGroupDetails {
  return {
    ...details,
    invoices: (details.invoices ?? []).map((invoice) => ({
      ...invoice,
      invoice_line_items: invoice.invoice_line_items ?? [],
    })),
    orphan_invoice_line_items: details.orphan_invoice_line_items ?? [],
  };
}

export function mergeInvoiceLineItems(
  invoice: Invoice,
  lineItems: InvoiceLineItem[],
): Invoice {
  return {
    ...invoice,
    invoice_line_items: lineItems.slice().sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '')),
  };
}

export function applyInvoiceListPatch(
  details: InvoiceGroupDetails,
  invoiceId: string,
  patch: Partial<Invoice> | null,
  event: 'created' | 'updated' | 'deleted',
): InvoiceGroupDetails {
  const invoices = details.invoices ?? [];

  if (event === 'deleted') {
    return {
      ...details,
      invoices: invoices.filter((inv) => inv.id !== invoiceId),
    };
  }

  if (!patch) {
    return details;
  }

  const existingIndex = invoices.findIndex((inv) => inv.id === invoiceId);
  const merged: Invoice = {
    ...(existingIndex >= 0 ? invoices[existingIndex] : { invoice_line_items: [] }),
    ...patch,
    id: invoiceId,
    invoice_line_items:
      existingIndex >= 0 ? invoices[existingIndex].invoice_line_items ?? [] : [],
  };

  if (existingIndex >= 0) {
    const next = invoices.slice();
    next[existingIndex] = merged;
    return { ...details, invoices: next };
  }

  return {
    ...details,
    invoices: [...invoices, { ...merged, invoice_line_items: [] }],
  };
}
